import {
    deleteFilesTransportLoading,
    deleteFilesTransportRequest,
    deleteFilesTransportSuccess,
    deleteFilesTransportReject,
    deleteFilesTransportReset
} from "../../actions/filesTransport/delete";

export const deleteFilesTransport = (formData) => async (dispatch, getState) => {
    dispatch(deleteFilesTransportLoading());
    try {
        const { data } = await deleteFilesTransportRequest(formData, getState);
        dispatch(deleteFilesTransportSuccess(data))
    } catch (error) {
        dispatch(deleteFilesTransportReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteFilesTransportReset()) }, 3000);
    }
    return Promise.resolve();
};